/**
* @Author: zachalam
* @Date:   2017-01-09T14:53:09-08:00
* @Last modified by:   Daniel
* @Last modified time: 2017-03-02T15:31:35-08:00
*/



import React, { Component } from 'react';
import TripsNav from './TripsNav';
import TripsList from './TripsList';
import Container from '../../blocks/Container'

class Trips extends Component {
  render() {
    return (
      <div>
        <TripsNav page="trips" />
        <Container>
          <TripsList trips={this.props.trips} cancelTrip={this.props.cancelTrip} />
        </Container>
      </div>
    );
  }
}

export default Trips;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/Trips.jsx